<!--
@component
"New" chip that hides itself after `expiresAtMs`.

@see Chip
-->
<script lang="ts">
  import { browser } from "$app/environment";

  import Chip from "./Chip.svelte";

  interface Props {
    expiresAtMs: number;
    label?: string;
    variant?: "primary" | "accent-blue" | "accent-pink";
  }

  let { expiresAtMs, label = "New", variant = "primary" }: Props = $props();

  // Only evaluate on the client to avoid SSR/client time mismatch.
  let visible = $derived(browser && Date.now() < expiresAtMs);
</script>

{#if visible}
  <Chip {variant}>{label}</Chip>
{/if}
